// Cookie consent banner (LSSI-CE art. 22.2). Aparece na SPA mentres
// non haxa consentimento gardado en localStorage. Esencial-only por agora
// (cero tracking, cero analytics) pero o banner é boa praxe: cando un día
// se engada analítica, a infraestrutura xa estará lista.
//
// A landing SSR `chain.leyro.es/` ten o seu propio banner inline; este
// cubre a SPA `chain.leyro.es/marketplace/*` que ata agora non o tiña.
// Mesma clave de storage (`leyrochain.cookie_consent_v1`) → un só accept
// silencia ambos.

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'leyrochain.cookie_consent_v1';

export default function CookieBanner(): JSX.Element | null {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== 'accepted') setVisible(true);
    } catch {
      // localStorage disabled → still show, opt-in always wins
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const onAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      /* storage disabled — banner hides anyway */
    }
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t('cookieBanner.ariaLabel')}
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-neutral-200 bg-white/95 px-4 py-3 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] backdrop-blur"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="m-0 text-sm leading-relaxed text-neutral-700">{t('cookieBanner.text')}</p>
        <div className="flex shrink-0 items-center gap-2">
          <a
            href="/legal/cookies"
            className="rounded-md border border-neutral-300 px-3 py-1.5 text-sm font-medium text-neutral-700 hover:bg-neutral-50"
          >
            {t('cookieBanner.more')}
          </a>
          <button
            type="button"
            onClick={onAccept}
            className="rounded-md bg-[#0E5C3D] px-4 py-1.5 text-sm font-medium text-white hover:bg-[#0a4a30]"
          >
            {t('cookieBanner.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
